import { sign } from "@/util/sign.js"
const common = {
  deepClone(origin, target) {
    var _this = this;
    var target = target || {};
    for (var prop in target) {
      if (target.hasOwnProperty(prop)) {
        if (target[prop] !== null && typeof target[prop] === 'object') {
          origin[prop] = Object.prototype.toString.call(target[prop]) === '[object Array]' ? [] : {};
          _this.deepClone(origin[prop], target[prop]);
        } else {
          origin[prop] = target[prop];
        }
      }
    }
  }
}

// 正则校验规则
// 大于0小于100的正整数  [ /^(?:0|[1-9][0-9]?|100)(\.[0-9]{0,2})?$/ ]
export const REG_EXP = {
  mobilePhone: /^1\d{10}/,
  email: /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
  money: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
  identityCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)(?![~!@#$%^&*()_+/*]+$)[0-9A-Za-z~!@#$%^&*()_+/*]{6,16}$/,
  loginName: /^[a-zA-Z0-9]{6,20}$/,

};

/**
 * 计算 el-table 的最大高度
 * @param {HTMLElement} el 表格或其容器元素
 * @param {Object} opts 配置项
 * @param {Number} opts.bottomHeight 表格下方需预留的高度（分页器等），默认 60
 * @param {Number} opts.minHeight 最小高度限制，默认 200
 * @returns {Number} 表格最大高度
 */
export let calcTableHeight = (el, opts = {}) => {
  const { bottomHeight = 60, minHeight = 200 } = opts;
  const screenHeight = window.innerHeight || document.documentElement.clientHeight;
  // 元素顶部到视口顶部的距离
  const rect = el && el.getBoundingClientRect ? el.getBoundingClientRect() : { top: 0 };
  // 视口高度 - 表格顶部到视口顶部的距离 - 下方分页器预留
  let height = screenHeight - rect.top - bottomHeight;
  // 防异常：不超过视口高度（避免页面滚动时 rect.top 为负导致无限放大）
  height = Math.min(height, screenHeight);
  return Math.max(height, minHeight);
}

// 导出
export let exportData = (obj, url)=>{
  obj.timestamp = new Date().getTime();
  obj.token = localStorage.getItem('token');
  let str = '';
  Object.keys(obj).forEach((item)=>{
    str += `&${item}=${obj[item]}`
  })
  let data = sign(obj);
  let _baerUrl = process.env.VUE_APP_BASE_API
  console.log(`${_baerUrl}${url}?sign=${data}${str}`,3)
  window.open(`${_baerUrl}${url}?sign=${data}${str}`)
}
 

export default common;